const production = {
  apiUrl: "",
  apiImages: "",
  apiPath: "/engine/ajax.php?type=react",
};

const development = {
  apiUrl: "https://rpmserver.com",
  apiImages: "https://rpmserver.com",
  apiPath: "https://rpmserver.com/engine/ajax.php?type=react",
};

const api = process.env.NODE_ENV === "development" ? development : production;

export default api;
